/*
* COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.

* This software is only to be used for the purpose for which it has been
* provided. No part of it is to be reproduced, disassembled, transmitted,
* stored in a retrieval system nor translated in any human or computer
* language in any way or for any other purposes whatsoever without the
* prior written consent of HSBC Holdings plc.

*/
/**
 * author: tman
 */

import React from 'react';
import PropTypes from 'prop-types';
import {Button} from 'react-bootstrap';

const UploadAddButton = (props) => {
    const { addBtnText,onAddAction ,addBtnStatus} = props;
    return (
        <div className="add-btn-row" style={{display:addBtnStatus ? '':'none'}} >
            <Button onClick={onAddAction} disabled={ false } data-key={ addBtnText.dataKey }>
                <i aria-hidden={true} className="icon icon-add">{}</i>
                { addBtnText.text }
            </Button>
        </div>
    )
};

UploadAddButton.propTypes = {
    addBtnText: PropTypes.object.isRequired,
    addBtnStatus:PropTypes.bool,
    onAddAction:PropTypes.func
};

UploadAddButton.defaultProps = {
    content: {}

};

export default UploadAddButton;



// WEBPACK FOOTER //
// ./src/views/AOFormReview/components/UploadAddButton/index.js